import script from "./ContentApp.vue?vue&type=script&setup=true&lang=js"
export * from "./ContentApp.vue?vue&type=script&setup=true&lang=js"

import "./ContentApp.vue?vue&type=style&index=0&id=19b1b103&lang=scss"

const __exports__ = script;

export default __exports__